var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94024 1.55388C9.22024 0.815375 10.2799 0.815375 10.5607 1.55388L12.372 6.57112C12.4352 6.73456 12.5465 6.875 12.6911 6.97388C12.8358 7.07277 13.007 7.12546 13.1822 7.125H17.6334C18.4559 7.125 18.8146 8.14875 18.168 8.65013L15.0005 11.5C14.8586 11.6091 14.7549 11.7603 14.7043 11.932C14.6537 12.1036 14.6587 12.2869 14.7187 12.4555L15.8755 17.3581C16.1572 18.1456 15.2455 18.822 14.556 18.3372L10.2536 15.6073C10.1063 15.5037 9.93058 15.4481 9.75049 15.4481C9.57041 15.4481 9.39471 15.5037 9.24737 15.6073L4.94499 18.3372C4.25637 18.822 3.34374 18.1447 3.62549 17.3581L4.78224 12.4555C4.84225 12.2869 4.84731 12.1036 4.79669 11.932C4.74607 11.7603 4.64238 11.6091 4.50049 11.5L1.33299 8.65013C0.685494 8.14875 1.04599 7.125 1.86674 7.125H6.31787C6.49312 7.12558 6.66443 7.07294 6.80911 6.97404C6.95379 6.87513 7.06504 6.73463 7.12812 6.57112L8.93937 1.55388H8.94024Z",
    stroke: "#72767D",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4beee96dfd02f3234183e477a3881808.svg";
export { ForwardRef as ReactComponent };